import {Button, Div, Label} from 'components';
import React, {useEffect, useRef, useState} from 'react';
import {Log, widthScale, widthScreen} from 'utils';
import {Ecolors} from 'constant';
// import ViewPager from '@react-native-community/viewpager';
// import PagerView from 'react-native-pager-view';
import {FlatList, StyleSheet} from 'react-native';

interface IData {
  component: (a?: any) => any;
  title: string;
  key: string;
}

function Tabbar(p: {
  activeTab: number;
  multilanguage?: boolean;
  data: Array<IData>;
  goToPage?: (e: number) => void;
}) {
  const flatlistRef = useRef<any>(null);
  const size =
    p.data?.length <= 3 ? widthScreen / p.data.length : widthScreen / 3;

  useEffect(() => {
    gotoActiveHeader(p.activeTab);
    return () => {};
  }, [p.activeTab]);

  const gotoActiveHeader = (index: number) => {
    if (flatlistRef.current) {
      flatlistRef.current.scrollToOffset({
        offset: (index > 0 ? index - 1 : index) * size,
        animated: true,
      });
    }
  };

  const renderItem = (t: {item: IData; index: number}) => {
    const {item, index} = t;
    const isFocus = p.activeTab == index;
    return (
      <Button
        onPress={() => {
          p.goToPage && p.goToPage(index);
        }}
        height={50}
        borderBottomWidth={2}
        borderBottomColor={isFocus ? Ecolors.mainColor : Ecolors.spaceColor}
        style={{
          width: size,
        }}
        alignItems={'center'}
        justifyContent={'center'}
        flexDirection={'row'}
        key={item.title}>
        <Label
          textAlign={'center'}
          multilanguage={p.multilanguage}
          size={14}
          fontWeight={'700'}
          color={isFocus ? Ecolors.textColor : Ecolors.grayColor}>
          {item.title}
        </Label>
      </Button>
    );
  };

  return (
    <Div backgroundColor={Ecolors.white}>
      <FlatList
        ref={flatlistRef}
        horizontal={true}
        showsHorizontalScrollIndicator={false}
        keyExtractor={(item: IData, index: number) => `key${item.key}`}
        data={p.data}
        extraData={p.data}
        renderItem={renderItem}
        getItemLayout={(data, index) => ({
          length: index * size,
          offset: index,
          index: index,
        })}
      />
    </Div>
  );
}

function TabViewComp(Props: {
  data: Array<IData>;
  initPage?: number;
  multilanguage?: boolean;
  onChange?: (t: number) => void;
}) {
  const TabViewRef = useRef<any>(null);
  const [activeTab, setActiveTab] = useState(Props.initPage || 0);

  const onPageSelected = (e: any) => {
    setActiveTab(e);
    Props.onChange && Props.onChange(e);
  };

  const goToPage = (index: number) => {
    onPageSelected(index);
    if (TabViewRef.current) {
      TabViewRef.current?.scrollToOffset({
        animated: false,
        offset: (index ?? 0) * widthScreen,
      });
    }
  };

  const renderItem = ({item, index}) => {
    return (
      <Div
        style={{
          width: widthScreen,
          height: '100%',
        }}>
        {item.component({
          activeTab,
        })}
      </Div>
    );
  };

  return (
    <Div flex={1}>
      <Tabbar
        activeTab={activeTab}
        multilanguage={Props.multilanguage}
        data={Props.data}
        goToPage={goToPage}
      />
      <Div height={10} />
      <FlatList
        ref={TabViewRef}
        horizontal={true}
        scrollEnabled={false}
        showsHorizontalScrollIndicator={false}
        keyExtractor={(item: IData, index: number) => `key${item.key}`}
        data={Props.data}
        extraData={Props.data}
        renderItem={renderItem}
        getItemLayout={(data, index) => ({
          length: index * widthScreen,
          offset: index,
          index: index,
        })}
      />
    </Div>
  );
}

const styles = StyleSheet.create({
  viewPager: {
    flex: 1,
  },
});

export default React.memo(TabViewComp);
